export const ArrowDownForSelectedGroup = () => (
  <svg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.53033 0.46967C9.82322 0.762563 9.82322 1.23744 9.53033 1.53033L5.53033 5.53033C5.23744 5.82322 4.76256 5.82322 4.46967 5.53033L0.469669 1.53033C0.176777 1.23744 0.176777 0.762563 0.469669 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L5 3.93934L8.46967 0.46967C8.76256 0.176777 9.23744 0.176777 9.53033 0.46967Z'
      fill='#3B89F6'
    />
  </svg>
);

export const ArrowRightDirection = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.21967 12.7803C4.92678 12.4874 4.92678 12.0126 5.21967 11.7197L8.68934 8.25L5.21967 4.78033C4.92678 4.48744 4.92678 4.01256 5.21967 3.71967C5.51256 3.42678 5.98744 3.42678 6.28033 3.71967L10.2803 7.71967C10.5732 8.01256 10.5732 8.48744 10.2803 8.78033L6.28033 12.7803C5.98744 13.0732 5.51256 13.0732 5.21967 12.7803Z'
      fill='#3B89F6'
    />
  </svg>
);
